import { createFileRoute } from "@tanstack/react-router";
import AdminSettingDetailPage from "@/pages/admin/settings/detail";
import { useSettingsPermissions } from "@/pages/admin/settings";

export const Route = createFileRoute("/app/admin/settings/$settingId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { settingId } = Route.useParams();
  const { userCanEditAllSettingTags, userCanViewAllSettingTags } = useSettingsPermissions();

  return (
    <AdminSettingDetailPage
      settingId={settingId}
      userCanEditAllSettingTags={userCanEditAllSettingTags}
      userCanViewAllSettingTags={userCanViewAllSettingTags}
    />
  );
}
